const ACCOUNT_ID = "7687";
const CATALOG = "clarev";

/** The session id the Bloomreach pixel stores, which ties a request to the shopper's other Bloomreach events. */
const getBrUid = () => {
  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith("_br_uid_2="));

  return cookie ? decodeURIComponent(cookie.slice("_br_uid_2=".length)) : "";
};

const generateRequestId = () =>
  Math.floor(Math.random() * 1e12)
    .toString()
    .padStart(13, "0");

/**
 * Query suggestions and suggested products for a partial search, from
 * Bloomreach's Suggest API.
 *
 * @param {string} query
 * @param {object} [options]
 * @param {"production"|"staging"} [options.env]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<{ queries: string[], products: { pid: string }[] }>}
 *   `pid` is the product handle.
 */
export async function fetchSuggestions(
  query,
  { env = "production", signal } = {},
) {
  const host =
    env === "staging" ? "staging-suggest.dxpapi.com" : "suggest.dxpapi.com";
  const url = new URL(`https://${host}/api/v2/suggest/`);

  url.search = new URLSearchParams({
    account_id: ACCOUNT_ID,
    catalog_views: CATALOG,
    request_id: generateRequestId(),
    request_type: "suggest",
    _br_uid_2: getBrUid(),
    url: window.location.href,
    ref_url: document.referrer || window.location.href,
    q: query,
  });

  const response = await fetch(url, {
    signal,
    headers: { accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Bloomreach suggest failed: ${response.status}`);
  }

  const data = await response.json();
  const group = data.suggestionGroups?.[0];

  return {
    queries: (group?.querySuggestions ?? []).map(({ query }) => query),
    products: group?.searchSuggestions ?? [],
  };
}
